import { FC, useState } from 'react';
import editIcon from '@assets/images/header/edit.svg';
import uploadIcon from '@assets/images/parrot/upload.svg';
// import Dialog from '@ui/dialog';
import Button from '@ui/button';
import styles from './edit.module.scss';
import Input from '@ui/input';
import { useDropzone } from 'react-dropzone';
import { useAddress } from '@hooks/use-address';
import { useSignPersonalMessage } from '@mysten/dapp-kit';
import { parrotApi } from '@libs/openapi';
import { OpenapiClientParrot } from 'src/openapi/parrot';
// import dayjs from 'dayjs';
import Dialog from '@ui/parrot/dialog';

interface OwnProps {
  toggleShowMenu(value?: boolean): void;
  user?: OpenapiClientParrot.GetUsersByWalletResponse;
}

const Edit: FC<OwnProps> = ({ toggleShowMenu, user }) => {
  const { mutateAsync: signMessage } = useSignPersonalMessage();
  const address = useAddress();
  const [visible, setVisible] = useState(false);
  const [file, setFile] = useState<string>('');
  const [data, setData] = useState<Blob>();
  const [name, setName] = useState('');
  const [loading, setLoading] = useState(false);
  // const [tip, setTip] = useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const onOpen = () => {
    setFile(user?.avatar || '');
    setData(undefined);
    setName(user?.username || '');

    // setTip(false);
    setVisible(true);
    toggleShowMenu();
  };

  const onDrop = (acceptedFiles: File[]) => {
    const formData = new FormData();
    acceptedFiles.forEach((file) => {
      formData.append('file', file);

      setData(file);
      const reader = new FileReader();
      reader.onload = (e: ProgressEvent<FileReader>) => {
        if (e.target) {
          setFile(e.target.result as string);
        }
      };
      reader.readAsDataURL(file);
    });
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    maxFiles: 1,
  });

  const save = async () => {
    if (!address) return;
    // if (user?.username_edit_at && Date.now() - dayjs(user.username_edit_at).valueOf() < 86400000) {
    //   setTip(true);
    //   return;
    // }
    setLoading(true);
    try {
      const result = await parrotApi.post('/passport/nonce', {
        body: {
          walletAddress: address,
        },
      });
      const signResult = await signMessage({
        message: new TextEncoder().encode(result.nonce),
      });
      const res = await parrotApi.post('/passport/auth', {
        body: {
          wallet_address: address,
          signature: signResult.signature,
        },
      });

      const ok = await parrotApi.patch('/users', {
        body: {
          file: data,
          username: name,
        },
        headers: {
          'Authorization': `Bearer ${res.token}`,
          'Content-Type': 'multipart/form-data',
        },
      });
      if (ok.username) {
        onClose();
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  return (
    <>
      <img src={editIcon} data-icon onClick={onOpen} className={styles.icon} />

      <Dialog isShown={visible} width={360} title={'Edit profile'} onCloseComplete={onClose}>
        {({ close }) => (
          <div className={styles.wrapper}>
            <div className={styles.title}>Profile photo</div>

            <div className={styles.main}>
              <div {...getRootProps({ className: 'dropzone' })} className={styles.img}>
                <img src={file ? file : uploadIcon} />
                <input {...getInputProps()} />
                <div className={styles.re_edit}>
                  <img src={editIcon} /> edit
                </div>
              </div>
            </div>

            <div className={styles.title1}>Username</div>
            <div className={styles.username}>
              <Input
                type="text"
                value={name}
                wrapperClassName={styles.new_wrapper}
                className={`${styles.input}`}
                onChangeText={setName}
              />
            </div>
            <div className={styles.tip}>you can change your username once every day</div>

            <div className={styles.btn}>
              <Button fullWidth onClick={close}>
                Close
              </Button>
              <Button fullWidth onClick={save} disabled={!file || !name} loading={loading}>
                {loading ? 'Loading...' : 'Save'}
              </Button>
            </div>
          </div>
        )}
      </Dialog>
    </>
  );
};

export default Edit;
